// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(registration)/auth": [6,[2]],
		"/(registration)/auth/login": [7,[2]],
		"/(registration)/auth/password-reset": [8,[2]],
		"/[prefix]": [9,[3]],
		"/[prefix]/(feature)/activity-approval-plan": [10,[3]],
		"/[prefix]/(feature)/activity-approval-real": [11,[3]],
		"/[prefix]/(feature)/activity-plan": [12,[3]],
		"/[prefix]/(feature)/activity-plan/[id]": [13,[3]],
		"/[prefix]/(feature)/activity-problem": [14,[3]],
		"/[prefix]/(feature)/activity-realization": [15,[3]],
		"/[prefix]/(feature)/activity-realization/[id]": [16,[3]],
		"/[prefix]/(feature)/activity-recap": [17,[3]],
		"/[prefix]/(feature)/activity-unplan": [18,[3]],
		"/[prefix]/(feature)/activity-unplan/[id]": [19,[3]],
		"/[prefix]/(feature)/customer-noo": [21,[3]],
		"/[prefix]/(feature)/customer-noo/[id]": [22,[3]],
		"/[prefix]/(feature)/customer": [20,[3]],
		"/[prefix]/(feature)/event": [23,[3]],
		"/[prefix]/(feature)/faq": [24,[3]],
		"/[prefix]/(main)/home": [36,[3,4]],
		"/[prefix]/(feature)/info": [25,[3]],
		"/[prefix]/(feature)/manual": [26,[3]],
		"/[prefix]/(feature)/memo": [27,[3]],
		"/[prefix]/(feature)/news": [28,[3]],
		"/[prefix]/(main)/notification": [37,[3,4]],
		"/[prefix]/(feature)/order-outstanding": [31,[3]],
		"/[prefix]/(feature)/order-recap": [32,[3]],
		"/[prefix]/(feature)/order": [29,[3]],
		"/[prefix]/(feature)/order/[id]": [30,[3]],
		"/[prefix]/(main)/product": [38,[3,4]],
		"/[prefix]/(main)/setting": [39,[3,4]],
		"/[prefix]/(feature)/setting/contact": [33,[3]],
		"/[prefix]/(feature)/staff-select": [35,[3]],
		"/[prefix]/(feature)/staff": [34,[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);